import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { firstValueFrom, map } from 'rxjs';
import { FeaturesService } from '../features-service/features.service';

@Injectable()
export class AccountFeatureGuard  {
  constructor(private featuresService: FeaturesService) {}

  async canActivateChild(childRoute: ActivatedRouteSnapshot): Promise<boolean> {
    this.featuresService.initAsync();

    if (childRoute.data.requiresFeature) {
      return firstValueFrom(
        this.featuresService.getEntitlement(childRoute.data.requiresFeature).pipe(map((feature) => feature.hasAccess)),
      );
    }

    return Promise.resolve(true);
  }
}
